// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"60":"3cf52184","251":"b2378ac7","426":"b9bc463e","433":"100b8fd2","459":"e9170247","469":"dc4a3f16","521":"50664ebe","640":"44384e41","655":"1ef5eafa"}[chunkId] + ".chunk.css";
};